<template>
    <!--<sponsor-show v-if="hasOldConfig" />
    <sponsor-show-new v-else />-->
    <sponsor-show-new v-if="hasNewConfig" />
    <sponsor-show v-else-if="hasOldConfig" />
</template>

<script>
import SponsorShow from './SponsorShow.vue'
import SponsorShowNew from './SponsorShowNew.vue'

export default {
  components: {
    SponsorShow,
    SponsorShowNew
  },
  computed: {
    event () {
      return this.$store.state.event.currentEvent
    },
    hasOldConfig () {
      const legacyConfig = this.event.sponsor_settings
      return legacyConfig && legacyConfig.types && legacyConfig.types.length > 0
    },
    hasNewConfig () {
      if (this.event.event_sponsor_config) {
        if (this.event.event_sponsor_config.levels.length > 0) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    }
  }
}
</script>
